import React from "react";
import { Award, BookOpen, UserCheck, MessageSquare } from "lucide-react";
import "./FacultyProfileSection.css";

const testimonials = [
  {
    text: "Prof. Sharma’s teaching method made complex topics easy to grasp. Truly inspiring!",
    student: "Riya Singh",
  },
  {
    text: "His mentorship was key to my success in the IAS exams.",
    student: "Aditya Kumar",
  },
];

const FacultyProfileSection = () => {
  return (
    <section className="faculty-profile-section-wrapper">
      <div className="faculty-profile-section-container">
        {/* Left: Photo */}
        <div className="faculty-profile-section-photo-wrapper">
          <img
            src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=400&q=80"
            alt="Prof. Sharma"
            className="faculty-profile-section-photo"
          />
        </div>

        {/* Right: Content */}
        <div className="faculty-profile-section-content">
          <h1 className="faculty-profile-section-name">Prof. Rajesh Sharma</h1>
          <p className="faculty-profile-section-title">Senior Faculty - Political Science</p>

          {/* Bio */}
          <section className="faculty-profile-section-block">
            <h2 className="faculty-profile-section-subheading">Biography</h2>
            <p className="faculty-profile-section-text">
              Prof. Sharma holds a Ph.D. in Political Science from Delhi University. With over 20 years of teaching experience, he has
              guided hundreds of aspirants towards success. Recipient of multiple national awards, he combines deep knowledge with
              student-centric mentorship.
            </p>
          </section>

          {/* Credentials */}
          <section className="faculty-profile-section-block">
            <h2 className="faculty-profile-section-subheading">
              <Award size={20} className="faculty-profile-section-icon" />
              Credentials
            </h2>
            <ul className="faculty-profile-section-list">
              <li>Ph.D. in Political Science, Delhi University</li>
              <li>Author of 3 best-selling UPSC guidebooks</li>
              <li>Former Consultant for Government Policy Reforms</li>
              <li>Recipient of National Excellence in Teaching Award (2018)</li>
            </ul>
          </section>

          {/* Teaching Style */}
          <section className="faculty-profile-section-block">
            <h2 className="faculty-profile-section-subheading">
              <BookOpen size={20} className="faculty-profile-section-icon" />
              Teaching Style
            </h2>
            <p className="faculty-profile-section-text">
              Prof. Sharma’s approach blends conceptual clarity with practical applications, encouraging critical thinking and
              active student engagement. His sessions include real-world examples, interactive discussions, and personalized feedback.
            </p>
          </section>

          {/* Video Introduction */}
          <section className="faculty-profile-section-block faculty-profile-section-video-block">
            <h2 className="faculty-profile-section-subheading">
              <UserCheck size={20} className="faculty-profile-section-icon" />
              Video Introduction
            </h2>
            <div className="faculty-profile-section-video-wrapper">
              <iframe
                src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                title="Prof. Sharma Introduction"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </section>

          {/* Testimonials */}
          <section className="faculty-profile-section-block">
            <h2 className="faculty-profile-section-subheading">
              <MessageSquare size={20} className="faculty-profile-section-icon" />
              Testimonials
            </h2>
            <div className="faculty-profile-section-testimonials">
              {testimonials.map(({ text, student }, i) => (
                <blockquote key={i} className="faculty-profile-section-testimonial">
                  <p>"{text}"</p>
                  <footer>— {student}</footer>
                </blockquote>
              ))}
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default FacultyProfileSection;
